import { Box, Button, ToggleSwitch } from "@bcc-ui/ui-components";
import { FeatureFlags } from "flagged";
import * as React from "react";

import style from "components/dev-tools/dev-tools.scss";
import { DEFAULT_FLAGS, featureFlagService } from "services/feature/FeatureFlagService";
import { getObject, RepositoryKey, setObject } from "utils/repository";

const FLAG_KEYS = Object.keys(DEFAULT_FLAGS);

function readStoredOverrides(): FeatureFlags {
    return getObject<FeatureFlags>(RepositoryKey.FEATURE_FLAGS) ?? {};
}

export const FeatureFlagsSection = () => {
    const { current: storedOverrides } = React.useRef(readStoredOverrides());
    const [pendingOverrides, setPendingOverrides] = React.useState<FeatureFlags>(storedOverrides);
    const isDirty = JSON.stringify(pendingOverrides) !== JSON.stringify(storedOverrides);

    const handleToggle = (flag: string, isEnabled: boolean) => {
        setPendingOverrides((previous) => ({ ...previous, [flag]: isEnabled }));
    };

    const handleReload = () => {
        setObject(RepositoryKey.FEATURE_FLAGS, pendingOverrides);
        window.location.reload();
    };

    return (
        <Box columnLayout gap="Md">
            <Box columnLayout gap="Sm" flexWrap="Wrap" className={style.contentSection}>
                {FLAG_KEYS.map((flag) => (
                    <ToggleSwitch
                        key={flag}
                        type="checkbox"
                        name={flag}
                        label={flag}
                        hideLabelSection={false}
                        defaultChecked={featureFlagService.isFeatureEnabled(flag)}
                        onChange={(event) => handleToggle(flag, event.target.checked)}
                    />
                ))}
            </Box>
            {isDirty && (
                <Button variant="Primary" onClick={handleReload}>
                    Reload to apply changes
                </Button>
            )}
        </Box>
    );
};
